<template>
	<!-- 注册协议 -->
	<div class="registXyBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- back -->
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">云锦文学城用户隐私协议</p>
				</div>
			</div>
		</van-sticky>
		<div class="txt">
			<p>更新时间：2020年10月1日</p>
			<p>生效时间：2020年10月1日</p>
			<h4>首部及导言</h4>
			<p>本《云锦文学城用户隐私政策》（下简称“本政策”）适用于西安云卷云书网络科技有限责任公司（下简称“我司”）全部产品和服务，包括云锦文学城小说阅读平台web端、iOS端应用程序、安卓端应用程序等全部终端客户端。请您在使用各项产品或服务前，仔细阅读并充分理解本隐私政策的全部内容。一旦您使用我司的产品或服务，即表示您同意我们按照本隐私政策使用和处理您的相关信息。</p>
			<p>我们可能会不时依据法律法规或业务调整对本隐私政策进行修订。当本隐私政策发生变更后，我们会在版本更新后通过在显著位置提示或推送通知、消息等形式向您展示变更后的内容。</p>
			<p>您需理解，只有在您确认并同意变更后的《云锦文学城用户隐私政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，可能导致您不能完整使用相关服务和功能，或者无法达到我们拟达到的服务效果。</p>
			<h4>一、用户个人信息保护与隐私保护</h4>
			<p>1.1 保护用户个人信息是我司的一项基本原则。我司视用户信息安全与隐私保护为基本底线。我们致力于提升信息处理的透明度，增强您对信息管理的便捷性，保障您的信息安全和通信安全。严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：</p>
			<p>（1）安全可靠：我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失；</p>
			<p>（2）保护通信秘密：我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务；</p>
			<p>（3）合理必要：为了向您和其他用户更好地提供服务，我们将收集合理、必要的信息；</p>
			<p>（4）清晰透明：我们努力使用简明易懂的表述向您介绍隐私政策，以便您清晰地了解我们的信息政策；</p>
			<p>（5）将隐私保护融入产品设计：我们在产品或服务开发的各个环节，综合法律、产品、设计的多方因素，融入隐私保护的理念，如设置客服通道等。</p>
			<p>1.2 您在注册账号或使用本服务的过程中，可能需要填写一些必要的信息（详见第二章，我们可能会收集的信息）。根据国家或地区法律法规的特殊规定，您可能需要填写真实的身份信息。若您填写的真实信息不完整，则可能在使用服务过程中受到限制。一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。当我们的产品或服务发生停止运营的情形时，我们将采取通知或公告的形式通知您，并在合理的期限内删除或匿名化处理您的个人信息；</p>
			<p>个人信息存储和超期处理方式：我们在中华人民共和国境内运营中收集和产生的个人信息，均存储在中国境内；</p>
			<p>存储期限：登录信息不少于三个月、交易信息自交易完成之日起不少于一年，记录备份不少于60日，法律法规另有规定的除外。在您的个人信息超出存储期限后，我们会根据适用的反馈要求删除您的个人信息、或使其匿名化处理。</p>
			<p>1.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
			<p>1.4 我司非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您法定监护人的同意。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过网站中的联系方式与我们联系。</p>
			<p>1.5 未经您的同意，我司不会向我司以外的任何公司、组织和个人披露您的个人信息，保证不对外公开或向无关第三方披露或提供用户注册资料及用户在使用网络服务时存储在我司平台、服务器或数据库的非公开内容和信息，但下列情况除外：</p>
			<p>（1）事先获得用户的明确授权；</p>
			<p>（2）根据有关的法律法规要求；</p>
			<p>（3）按照相关政府主管部门和司法机关的要求；</p>
			<p>（4）为维护社会公众的利益；</p>
			<p>（5）为维护本站的合法利益；</p>
			<p>（6）符合用户协议精神的其他情况。</p>
			<p>1.6 因用户使用第三方服务或者设备，可能导致用户信息通过其他方式透露给第三方，用户需自行了解第三方对用户信息保护的相关条款，我司不承担由此产生的风险。上述情形包括：用户在移动设备上使用第三方应用程序、因第三方应用程序收集的用户信息发送至第三方进行处理等。</p>
			<p>1.7您理解并同意：如您是通过QQ号码或微信帐号开通的本服务的，则关于您的QQ号码的获取、使用、找回及微信帐号的的注册、登录、使用方式请参考《QQ号码规则》（链接地址：http://zc.qq.com/chs/agreement1_chs.html）及《腾讯微信使用条款和隐私政策》（链接地址：http://support.weixin.qq.com/cgi-bin/mmsupport-bin/readtemplate?stype=&promote=&fr=&lang=zh_CN&ADTAG=&check=false&nav=faq&t=weixin_agreement）注：链接地址可能会发生改变，以QQ和微信官方信息为准。</p>
			<h4>二、我们可能会收集的信息</h4>
			<p>我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。我们可能会收集、储存下列与您有关的信息；对本政策的同意将被视为同意我们收集您的个人信息，并在法律规定及本政策约定的范围内进行使用。</p>
			<p>2.1 我们收集以下各类信息：</p>
			<p>2.1.1 账号服务所需信息：</p>
			<p>(1) 您在注册账户时填写的信息：<p class="weightFont">手机号码*、电子邮箱地址*</p>；</p>
			<p>(2) 我们可能会获得您在使用第三方合作伙伴的账号登录时，第三方向我们披露的信息，包括：用户名、头像等。对于这部分内容，请您仔细阅读第三方合作伙伴服务的用户政策或隐私政策；</p>
			<p>(3) 您在编辑资料时填写的信息：昵称、头像；</p>
			<p>(4) 个人账户资料显示：头像、昵称、<p class="weightFont">应用内虚拟币余额*、充值记录*、消费记录* </p>；</p>
			<p>(5) 实名认证: 您通过「实名认证」向我们提供的您相应身份信息*：<p class="weightFont">身份证*、护照*及其他身份证件信息*</p>；</p>
			<p>(6) 账户安全：我们需要收集您的一些信息来保障您的账号安全、判断您的账户及交易风险，包括如下信息：账号<p class="weightFont">登录地*</p>、登录<p class="weightFont">IP地址*</p>、登录时间、产品版本号、<p class="weightFont">交易信息*</p>、<p class="weightFont">实名认证信息*</p>；一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证与风险排除，以确保我们向您提供的产品和服务的安全性，保障您的权益不受侵害。</p>
			<p>2.1.2 产品或服务所需信息</p>
			<p>(1)为了能够更好地为您提供小说阅读服务、提升阅读体验、优化小说展示效果，我们需要收集如下信息：设备型号、设备品牌、设备唯一标识符、操作系统和应用程序版本及来源渠道、网络类型、登录IP地址*、日志信息*（操作日志、服务日志、开发日志、闪退日志）；</p>
			<p>(2) 客服/用户反馈功能：当您通过客服进行咨询、账号申诉功能时，我们可能需要收集您的账号信息以验证您的身份，也有可能收集您反馈意见和建议时填写的<p class="weightFont">手机号码*</p>、QQ号、微信号；</p>
			<p>(3) 您参加我们举办的活动时所提交的信息：<p class="weightFont">姓名*</p>、<p class="weightFont">手机号码*</p>、<p class="weightFont">收货地址*</p>。</p>
			<p>* 我们的部分服务可能需要您提供特定的个人敏感信息（本隐私政策中标注*）来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息；</p>
			* 个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。例如，个人敏感信息包括身份证件号码、个人生物识别信息、银行账号、通信内容、健康生理信息等。本隐私政策中的“个人信息”或“个人敏感信息”所包含的内容出自于GB/T35273《个人信息安全规范》，定义与《个人信息安全规范》中的定义一致。</p>
			<p>2.2 根据用户行为及产品特点，我司可能访问用户手机上的以下内容：</p>
			<p>2.2.1 对于使用安卓系统的用户，您在使用我们向您提供的相关产品时，为提供、处理、维护、改善、开发我们的商品或提供给您的服务之目的，该产品可能获取您终端设备的如下权限：</p>
			<p>（1）用户下载图书时，因需将图书数据存入SD卡内而写入/删除内部存储；</p>
			<p>（2）用户阅读已下载图书时，因需读取图书数据而读取内部存储；</p>
			<p>（3）为确认下载图书数据存放方式需判断用户是否插入SD卡而使用挂载文件系统权限；</p>
			<p>（4）为计算存储空间的空闲区域而使用获取应用大小权限；</p>
			<p>（5）用户使用语音朗读功能时，为保证来电时停止语音朗读而读取手机状态和身份；</p>
			<p>（6）角色配音功能和句子配音需要用到录制音频权限；</p>
			<p>（7）为用户上传头像时可以选择使用摄像机拍照而使用拍摄照片和视频、访问闪光灯权限；</p>
			<p>（8）为使用本软件联网功能而使用访问网络权限；</p>
			<p>（9）为判断用户当前网络状态以便提示用户而获取用户网络状态；</p>
			<p>（10）提示用户打开网络而使用改变网络状态权限；</p>
			<p>（11）用户进行下载图书操作时，当用户当前网络是2G/3G/4G时，为节约用户流量提示其打开wifi网络而使用获取、改变wifi状态权限；</p>
			<p>（12）为用户阅读时可以改变横竖屏方向而申请改变系统设置权限；</p>
			<p>（13）为用户调节手机亮度而读写系统设置项；</p>
			<p>（14）为保证用户在阅读的图书更新时能第一时间获得通知而允许程序开机自动运行、允许程序在手机屏幕关闭后后台进程仍然运行；</p>
			<p>（15）为发生异常情况时重启本软件而使用结束系统任务权限；</p>
			<p>（16）用户使用语音朗读功能和配音播放时为调节音量大小而使用修改声音设置权限；</p>
			<p>（17）为给用户手机发送图书更新通知时手机震动而使用允许振动权限；</p>
			<p>（18）为帮助用户解决本软件发生异常时的问题而读取系统日志；</p>
			<p>（19）为监测用户将图书分享到其他应用功能是否正常而使用允许程序获取当前或最近运行的应用权限；</p>
			<p>（20）为实现悬浮窗功能而使用显示系统窗口权限；</p>
			<p>（21）听书功能需要在锁屏时通过指纹快速解锁手机而使用指纹解锁权限；</p>
			<p>（22）为使用户在全屏阅读时，阅读页面显示电池电量信息而使用电池状态权限；</p>
			<p>（23）当用户在设置阅读界面常亮，需要使用保持屏幕常亮权限，使系统不会因为用户长时间不操作而关闭屏幕；</p>
			<p>（24）为了查明应用出现闪退后的进程或重启，需要操作后台进程功能的权限；</p>
			<p>（25）为支持直播功能需获得重新设置外拨电话路径的权限。</p>
			<p>2.2.2 对于使用IOS的用户，您在使用本软件时，为提供、处理、维护、改善、开发我们的商品和/或提供给您的服务之目的，本软件可能获取您终端设备的如下权限：</p>
			<p>（1）为使用播放功能或配音功能等获取用户声音之目的调取麦克风权限；</p>
			<p>（2）为实现用户上传头像功能以及发帖功能，使用手机相机权限；</p>
			<p>（3）为允许用户保存图片使用相册权限；</p>
			<p>（4）为实现软件正常运行使用网络权限。</p>
			<h4>三、我们可能如何使用信息</h4>
			<p>3.1 我们可能如何使用信息</p>
			<p>3.1.1用户同意我司基于下列原因需要使用用户的信息资源：</p>
			<p>（1）用户账户的找回；</p>
			<p>（2）安全保障。我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务中；</p>
			<p>（3）产品的开发和优化。当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。</p>
			<h4>四、您如何访问和控制自己的个人信息</h4>
			<p>4.1您对我们产品或服务中的您的个人信息享有多种方式的控制权，包括：您可以访问、更改、删除您的个人信息，撤销您之前作出的对个人信息的同意或注销您的账号。为便于您行使您的上述控制权，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以自行进行操作，如您在操作过程中有疑惑或困难，可以通过文末的方式联系我们来进行控制，我们会及时为您处理。</p>
			<p>4.1.1 访问您的个人信息</p>
			<p>您可以在我们的产品或服务中查询或访问您的相关个人信息，包括</p>
			<p>（1）账号信息：您可以登录您的个人账号，在个人主页中访问您的账号中的个人资料信息，包括：头像、昵称、简介；</p>
			<p>（2）使用信息：您可以通过书架页、搜索页、个人主页随时查阅您的浏览记录、书架添加记录、搜索记录等；</p>
			<p>（3）<p class="weightFont">交易消费信息*</p>：您可以通过访问「账户」页，查看您的<p class="weightFont">交易记录</p>*及<p class="weightFont">消费记录*</p>；</p>
			<p>（4）其他信息：如您在此访问过程中遇到操作问题的或如需获取其他前述无法获知的个人信息内容，您可通过文末提供的方式联系我们，我们将在核实您的身份后在合理期限内向您提供，但法律法规另有规定的或本政策另有约定的除外。</p>
			<p>4.1.2更正/修改您的个人信息</p>
			<p>您可以在我们的产品或服务中更正/修改您的相关个人信息。为便于您行使您的上述权利，我们为您提供了在线自行更正/修改和向我们提出更正/修改申请两种方式。出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
			<p>对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行更正/修改，操作指引如下：</p>
			<p>（1）“头像/昵称/简介”信息的更正/修改界面为个人主页（「我的」页）；<p>
			<p>（2）“<p class="weightFont">手机号码*/邮箱*/密码*</p>/第三方账号”信息的更正/修改界面为：您可以登录您的个人账号，访问个人主页。<p>
			<p>4.1.3 删除与注销</p>
			<p>一般而言，我们只会在法律法规规定或必需且最短的时间内保存您的个人信息。为便于您行使您的上述删除权，我们为您提供了在线自行删除和向我们提出删除申请两种方式。</p>
			<p>对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作指引和操作设置，您可以直接进行删除，一旦您删除后，我们即会对此类信息进行删除或匿名化处理，法律法规另有规定的除外。</p>
			<p>（1）“搜索历史”信息在App中的删除界面是：搜索框下点击清楚搜索记录按钮；</p>
			<p>（2）“浏览记录”信息在App中的删除界面为：书架-最近阅读-删除最近阅读。在以下情形下，您可以直接向我们提出删除您个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外：</p>
			<p>（1）我们处理个人信息的行为违反法律法规；</p>
			<p>（2）我们收集、使用您的个人信息，却未征得您的统一；</p>
			<p>（3）我们处理个人信息的行为违反了与您的约定；</p>
			<p>（4）您不再使用我们的产品或服务，或您注销了账号；</p>
			<p>（5）我们不再为您提供产品或服务。</p>
			<p>我们为您提供账号注销权限，您可以通过App中功能操作或联系我们的客服注销您的账号。操作界面：登录后进入「客服」页，提交投诉相关投诉意见。</p>
			<p>一旦您注销账号，将无法使用我们提供的全线用户产品的服务且自动放弃已有的权益，因此请您谨慎操作。除法律法规另有规定外，注销账号之后，我们将停止为您提供我们所有的产品和服务，您曾通过该账号使用的我们的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理。</p>
			<h4>五、政策更新</h4>
			<p>变更后的政策，我们将通过站内信息、页面提示、标注红点的方式另行向您说明对应信息的收集目的、范围及使用方式，并向您提供自主选择同意的方式，且在征得您明示同时后收集、使用您的个人信息。</p>
			<p>六、联系我们</p>
			<p>我们的联系方式：</p>
			<p>西安云卷云书网络科技有限责任公司</p>
			<p>客服电话: 18149013368（客服申诉处理时间为3-7天） </p>
			<p>客服页面：https://www.yjwxc.com/home/wcontroller/w_wenzhang.html </p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created() {
			this.urlStr = this.$route.query.url || '';
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.registXyBox {
		background-color: #fff;
		height: 100vh;
		width: 100vw;
		overflow-x: hidden;
		color: #000;
	}

	// 头部
	.headerBox {
		height: 160px;
		background-color: #FF4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;

		/*no*/
		.headerQuery {
			margin-top: 80px;
			padding: 0 20px;
			position: relative;
			display: flex;
			width: 100%;
			height: 80px;
			line-height: 80px;
			color: #000;


			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 10px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.txt {
		padding: 10px 30px;

		p {
			line-height: 50px;
			font-size: 26px;
			/*px*/
		}

		h4 {
			line-height: 50px;
			font-size: 28px;
			/*px*/
		}

		p.weightFont {
			line-height: 50px;
			font-size: 26px;
			/*px*/
			font-weight: bold;
			display: inline-block;
		}
	}
</style>
